import { DropdownMenuSeparator } from '@radix-ui/react-dropdown-menu';

import css from './styles.module.css';

export function MenuSeparator() {
  return <DropdownMenuSeparator className={css.separator} />;
}
